import { GrCircleQuestion } from "react-icons/gr";
import ModalInfo from "../../../components/lib/modalInfo";
import { useEffect, useState } from "react";
import ClientService from "../../../rest/clientService";
import CategorySelect from "../../../components/reusables/categorySelect";

const ProductEditFormStep2 = ({ formik }) => {
    const [preferences, setPreferences] = useState(null);

    useEffect(() => {
        ClientService.getClientAdminPreferences().then(setPreferences);
    }, []);

    return (
        <div className="space-y-6 max-w-xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-x-4 my-4">
                <label>
                    <div className="flex items-center justify-between">
                        SKU:
                        <ModalInfo icon={<GrCircleQuestion />} content="Código que facilita a organização dos itens. É um meio de você identificar produtos, sem precisar gravar seu código de barras por exemplo. Permite que você estabeleça seu próprio padrão para organização." />
                    </div>
                    <input className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.sku && formik.errors.sku ? 'border-red-500' : ''}`}
                        name="sku"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.sku} />

                    {formik.touched.sku && formik.errors.sku && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.sku}</p>)}
                </label>

                <label>
                    <div className="flex items-center justify-between">
                        Aviso de Limite :
                        <ModalInfo icon={<GrCircleQuestion />} content="Define o limite no qual seu estoque pode chegar até precisar de reposição. Um alerta será emitido quando o valor for atingido ou ultrapassado." />
                    </div>
                    <input className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.limit_warning && formik.errors.limit_warning ? 'border-red-500' : ''}`}
                        name="limit_warning"
                        type="number"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.limit_warning} />

                    {formik.touched.sku && formik.errors.limit_warning && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.limit_warning}</p>)}
                </label>
            </div>

            <label className="relative space-y-1">
                <p>Categoria</p>
                <CategorySelect
                    name="category"
                    value={formik.values.category}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    categories={preferences?.categories}
                />
                <p className={"text-red-500 text-xs font-medium min-h-[14px]"}>
                    {formik.touched.category && formik.errors.category}
                </p>
            </label>

            <label>
                <div className="flex items-center justify-between">
                    Descrição do Produto:
                    <ModalInfo icon={<GrCircleQuestion />} content="O campo de descrição do produto fica visível para todos os usuários, tanto na plataforma de gerenciamento, quanto na de compra (app)." />
                </div>
                <textarea className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.description && formik.errors.description ? 'border-red-500' : ''}`}
                    name="description"
                    type="text"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.description} />

                {formik.touched.sku && formik.errors.description && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.description}</p>)}
            </label>

            <label>
                <div className="flex items-center justify-between">
                    Observações:
                    <ModalInfo icon={<GrCircleQuestion />} content="O campo de observações fica visível apenas para usuários que utilizam a ferramenta de gerenciamento." />
                </div>
                <textarea className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.observations && formik.errors.observations ? 'border-red-500' : ''}`}
                    name="observations"
                    type="text"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.observations} />

                {formik.touched.observations && formik.errors.observations && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.observations}</p>)}
            </label>

            <div className="grid md:grid-cols-2 gap-4 mt-6">

                <label className="flex items-center gap-3 cursor-pointer">
                    <input
                        type="checkbox"
                        name="active"
                        checked={formik.values.active}
                        onChange={formik.handleChange}
                        className="w-4 h-4 accent-blue-600" />
                    <span className="text-sm font-medium text-gray-700"> Ativar produto no cardápio </span>
                </label>

                <label className="flex items-center gap-3 cursor-pointer">
                    <input
                        type="checkbox"
                        name="needsPreparation"
                        checked={formik.values.needsPreparation}
                        onChange={formik.handleChange}
                        className="w-4 h-4 accent-blue-600" />

                    <span className="text-sm font-medium text-gray-700"> Precisa de preparo pela cozinha </span>
                </label>
            </div>
        </div>
    );
};

export default ProductEditFormStep2;
